import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LICENSE_STORAGE_KEY = "tk-license";

export const api = axios.create({ baseURL: API });

// Attach the stored license key on every request (bearer-style gate, no login).
api.interceptors.request.use((config) => {
  const key = typeof window !== "undefined" ? localStorage.getItem(LICENSE_STORAGE_KEY) : null;
  if (key) config.headers["X-License-Key"] = key;
  return config;
});

// If the backend rejects the license, drop it locally and let the app re-lock.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Don't nuke the key on the verify call itself (it returns {valid:false}, not 401/403).
    if ((status === 401 || status === 403) && !url.includes("/license/verify")) {
      if (typeof window !== "undefined") {
        localStorage.removeItem(LICENSE_STORAGE_KEY);
        window.dispatchEvent(new Event("tk-license-invalid"));
      }
    }
    return Promise.reject(error);
  }
);

export const getSessions = () => api.get("/sessions").then((r) => r.data);
export const createSession = (payload) => api.post("/sessions", payload).then((r) => r.data);
export const deleteSession = (id) => api.delete(`/sessions/${id}`).then((r) => r.data);
export const getSpecs = () => api.get("/specs").then((r) => r.data);
export const decodeVin = (vin) => api.get(`/vin/${encodeURIComponent(vin)}`).then((r) => r.data);

export const createCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const verifyLicense = (licenseKey) => api.post("/license/verify", { license_key: licenseKey }).then((r) => r.data);

export const analyzeTireWear = (payload) => api.post("/scan/tire-wear", payload).then((r) => r.data);
export const saveReport = (payload) => api.post("/reports", payload).then((r) => r.data);
export const getReport = (id) => api.get(`/reports/${id}`).then((r) => r.data);

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const submitVehicleRequest = (payload) => api.post("/vehicle-request", payload).then((r) => r.data);

export const limitMsg = (err) => ([413, 429].includes(err?.response?.status) ? err.response.data?.detail : null);
